module.exports = {
  archiveRoomsFeature:
    process.env.REACT_APP_PROJECT_ARCHIVE_ROOM_FEATURE === 'true',
  coordinatorFeature:
    process.env.REACT_APP_PROJECT_COORDINATOR_FEATURE === 'true',
  pickupFeature: process.env.REACT_APP_PROJECT_PICKUP_FEATURE === 'true'
}
